module.exports = __webpack_public_path__ + "static/media/eye-active.1f9e06a6.svg";